var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Zlib from "zlib";
export function fetchGzippedFile(url, options = undefined) {
    return __awaiter(this, void 0, void 0, function* () {
        const ret = yield fetchGzippedFileWithBlob(url, options);
        return ret.ncodeImageText;
    });
}
export function fetchGzippedFileWithBlob(url, options = undefined) {
    return __awaiter(this, void 0, void 0, function* () {
        if (options === undefined) {
            options = {
                headers: {
                    'Content-Encoding': 'gzip, compress, br',
                    "dataType": "text",
                },
            };
        }
        let blob = undefined;
        const res = yield fetch(url, options);
        try {
            blob = yield res.blob();
        }
        catch (e) {
            console.log(res);
            console.log(e);
            throw (e);
        }
        if (!blob) {
            throw new Error("cannot get gzipped blob from URL");
        }
        const buffer = yield blob.arrayBuffer();
        const u8buf = new Uint8Array(buffer);
        return new Promise((resolve, reject) => {
            function gunzipCallback(res, blob, decompressed) {
                const txt = new TextDecoder("utf-8").decode(decompressed);
                resolve({
                    ncodeImageText: txt,
                    blob,
                    status: res.status,
                    ok: res.ok,
                    url: res.url,
                });
            }
            if (blob != null) {
                try {
                    // eslint-disable-next-line
                    const gunzip = new Zlib.gunzip(u8buf, (err, decompressed) => {
                        // console.error(err);
                        if (err) {
                            console.log(err);
                            reject({
                                ncodeImageText: undefined,
                                blob: undefined,
                                status: res.status,
                                ok: res.ok,
                                url: res.url,
                            });
                        }
                        gunzipCallback(res, blob, decompressed);
                    });
                }
                catch (e) {
                    reject({
                        ncodeImageText: undefined,
                        blob: undefined,
                        status: res.status,
                        ok: res.ok,
                        url: res.url,
                    });
                }
            }
        });
    });
}
//# sourceMappingURL=network.js.map